// File: src/components/MultiStepBar.jsx
import React from 'react';
import '../styles/MultiStepBar.css';

export default function MultiStepBar({ steps, currentStep }) {
  return (
    <div className="multi-step">
      {steps.map((label, idx) => {
        const stepNum = idx + 1;
        const isCompleted = stepNum < currentStep;
        const isActive    = stepNum === currentStep;

        return (
          <div
            key={idx}
            className={`step ${isCompleted ? 'completed' : ''} ${isActive ? 'active' : ''}`}
          >
            <div className="step-circle">{stepNum}</div>
            <div className="step-label">{label}</div>
          </div>
        );
      })}
    </div>
  );
}
